import { Layer, Stack, TableToolbar, TableToolbarContent } from "@carbon/react";
import { MultiSelectAppliedFilter } from "@flaminem/ui-components";
import React, { ReactNode, useState } from "react";

import { AppliedFilters } from "src/components/Filters/AppliedFilters.tsx";
import FilterableMultiPicker from "src/components/Pickers/FilterableMultiPickerFormField.tsx";
import { TableToolbarFilter } from "src/components/Tables/TableToolbarFilter.tsx";
import { IdentifiersValues } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCasesPrepareQuery.ts";
import { useT } from "src/internationalization";

type AlertsToolbarProps = {
  allIdentifiers: IdentifiersValues[];
  filters: {
    identifierValues: string[];
  };
  handleOnFiltersChange: (filters: { identifierValues: string[] }) => void;
  children: ReactNode;
  leftChildren?: ReactNode;
};

const RelatedCasesToolbar: React.FC<AlertsToolbarProps> = ({
  allIdentifiers,
  filters,
  handleOnFiltersChange,
  children,
  leftChildren,
}) => {
  const [identifierValues, setIdentifierValues] = useState<string[]>(filters.identifierValues);
  const selectedItems = allIdentifiers.filter((identifier) =>
    identifierValues.includes(identifier.value)
  );
  const t = useT();

  return (
    <>
      <TableToolbar aria-label="data table toolbar">
        <TableToolbarContent className="border-b border-solid border-borderSubtle01">
          {leftChildren}
          <TableToolbarFilter
            onPopoverOpen={() => setIdentifierValues(filters.identifierValues)}
            onApplyFilter={() => handleOnFiltersChange({ identifierValues })}
            onResetFilter={() => handleOnFiltersChange({ identifierValues: [] })}
            onPopoverClose={() => {
              setIdentifierValues(filters.identifierValues);
            }}
            numberOfFiltersApplied={filters.identifierValues.length > 0 ? 1 : 0}
          >
            <Layer level={1} className="w-[500px] pb-7">
              <Stack gap={5}>
                <FilterableMultiPicker
                  id="rules"
                  titleText={t("component.widget.related.cases.filter.form.identifiers.title")}
                  helperText={t("component.widget.related.cases.filter.form.identifiers.helper")}
                  items={allIdentifiers}
                  selectedItems={selectedItems}
                  itemToString={(item) => item?.value ?? ""}
                  onChange={({ selectedItems }) => {
                    const ids = selectedItems.map((item) => item.value);
                    setIdentifierValues(ids);
                  }}
                />
              </Stack>
            </Layer>
          </TableToolbarFilter>
          {children}
        </TableToolbarContent>
      </TableToolbar>
      {filters.identifierValues && filters.identifierValues.length > 0 && (
        <div className="flex w-full bg-layer">
          <Layer className={"p-5"}>
            <AppliedFilters onClear={() => handleOnFiltersChange({ identifierValues: [] })}>
              {filters.identifierValues && filters.identifierValues.length > 0 && (
                <MultiSelectAppliedFilter
                  items={filters.identifierValues.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  title={t("page.alerts.table.filters.applied.identifiers")}
                  onChange={(values) => handleOnFiltersChange({ identifierValues: values })}
                />
              )}
            </AppliedFilters>
          </Layer>
        </div>
      )}
    </>
  );
};

export default RelatedCasesToolbar;
